import {Component, Inject, OnInit} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-alert-hs',
  templateUrl: './alert-hs.component.html',
  styleUrls: ['./alert-hs.component.scss']
})
export class AlertHsComponent implements OnInit {

    loading = false;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AlertHsComponent>,
        public authenticationService: AuthenticationService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
